module.exports = __webpack_public_path__ + "img/Streeme-logoFooter.60e699.png";